import React from 'react';
import { DeleteIcon, EditIcon } from '../../../components/common/SvgIcon';

const TemplateTableRow = ({ template, onEdit, onDelete, isProActive }) => {

  const ProBadge = `${LEGAL_PAGES.assets_url}/images/icons/pro-badge.png`;
  const getTemplateIcon = (name) => {
    const lowerName = name.toLowerCase();
    if (lowerName.includes('term')) return '📄';
    if (lowerName.includes('privacy')) return '🔒';
    if (lowerName.includes('cookie')) return '🍪';
    if (lowerName.includes('dmca') || lowerName.includes('copyright')) return '©';
    if (lowerName.includes('ccpa') || lowerName.includes('california')) return '🏛️';
    if (lowerName.includes('gdpr')) return '🇪🇺';
    if (lowerName.includes('disclaimer')) return '⚠️';
    if (lowerName.includes('refund')) return '💰';
    if (lowerName.includes('affiliate')) return '🤝';
    if (lowerName.includes('about')) return 'ℹ️';
    return '📋';
  };

  const isLocked = template.type === 'pro' && !isProActive;

  return (
    <tr
      className={`
        transition-colors
        ${isLocked
          ? 'bg-gray-50 text-gray-400 cursor-not-allowed'
          : 'hover:bg-[#FAFAFA]'
        }
      `}
    >
      {/* ID */}
      <td className="py-4 px-6">
        <span className="text-sm font-medium">
          #{template.id}
        </span>
      </td>

      {/* Title */}
      <td className="py-4 px-6">
        <div className="flex items-center gap-3">
          <span className="text-2xl opacity-70">
            {getTemplateIcon(template.name)}
          </span>
          <span className="text-sm font-medium">
            {template.name}
          </span>
        </div>
      </td>

      {/* Type */}
      <td className="py-4 px-6">
        {template.type === 'free' ? (
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200">
            FREE
          </span>
        ) : (
          <span
            className={`
              ${isLocked ? 'opacity-60' : ''}
            `}
          >
            <img
              src={ProBadge}
              alt="Pro"
              className="h-5 w-auto"
            />
          </span>
        )}
      </td>

      {/* Actions */}
      <td className="py-4 px-6">
        <div className="flex items-center justify-end gap-2">
          {/* Edit */}
          <button
            onClick={() => !isLocked && onEdit(template)}
            disabled={isLocked}
            className={`
              p-2 rounded-xl transition-colors
              ${isLocked
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'text-[#6F6F7B] cursor-pointer hover:text-lgp-color hover:bg-lgp-body'
              }
            `}
            title={isLocked ? 'Upgrade to PRO to edit' : 'Edit template'}
          >
            <EditIcon />
          </button>
          <button
            onClick={() => !isLocked && onDelete(template.id, template.name)}
            disabled={isLocked}
            className={`
              p-2 rounded-xl transition-colors
              ${isLocked
                ? 'text-gray-400 cursor-not-allowed'
                : 'text-[#6F6F7B] cursor-pointer hover:text-red-600 hover:bg-red-50'
              }
            `}
            title={isLocked ? 'Upgrade to PRO to delete' : 'Delete page'}
          >
            <DeleteIcon />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default TemplateTableRow;
